import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DeepAssign } from "utils/deep-assign";
import { iOrganization } from "../../../@sdk/user-management/user-management.models";
import { iOrganizationSlice } from "./workspace.model";
import { DeepPartial } from "utils/deep-partial";

const OrganizationsSlice = createSlice({
  name: "organizations",
  initialState: {
    organization: undefined,
    credits: undefined,
  } as iOrganizationSlice,
  reducers: {
    setOrganization(state, action: PayloadAction<iOrganization>) {
      state.organization = action.payload;
    },
    patchOrganization(
      state,
      action: PayloadAction<DeepPartial<iOrganization>>
    ) {
      DeepAssign(state.organization, action.payload);
    },
  },
});

export const OrganizationsSliceReducers = OrganizationsSlice.reducer;

export const OrganizationsSliceActions = OrganizationsSlice.actions;
